// frontend/src/components/Modal/InfoModal.js
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import Typography from '../Typography';
import { useTranslation } from 'react-i18next';
import VehicleIcon from '../Icons/VehicleIcon';
import { theme } from '../../theme';

const InfoModal = ({ isOpen, onClose, onContinue }) => {
  const { t } = useTranslation('eventEnroll');
  return (
    <Modal title={t('vehicleSelection.infoModal.header')} onClose={onContinue} isOpen={isOpen} maxWidth="350px">
      <InfoContainer>
        <InfoBlock>
          <InfoImageContainer>
            <VehicleIcon fill={theme.colors.brandMain} />
            {/* <img src="/icons/vehicle.svg" alt="info-icon" /> */}
          </InfoImageContainer>
          <Typography $variant="title-5-semibold" $align="center">
            {t('vehicleSelection.infoModal.title')}
            {/* Este evento requiere un vehículo para inscribirte. */}
          </Typography>
          <Typography $variant="body-1-regular" $align="center">
            {t('vehicleSelection.infoModal.subtitle')}
            {/* Para participar en este evento, debes inscribir un vehículo. Puedes seleccionar uno existente o añadir uno nuevo. */}
          </Typography>
        </InfoBlock>
        <ActionsContainer>
          <Button
            onClick={onContinue}
            $fullWidth
            $contentAlign="center"
            size="l"
            style={{ flexGrow: "1" }}
          >
            {/* Continuar */}
            {t('vehicleSelection.infoModal.continue')}

          </Button>
        </ActionsContainer>
      </InfoContainer>
    </Modal>
  );
};

InfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default InfoModal;

const InfoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const InfoImageContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.fill.brandAlphaMain16};
  border-radius: ${({ theme }) => theme.radius.xl};
  display: flex;
  height: 60px;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.sizing.xs};
  min-width: 60px;
`;

const ActionsContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  display: flex;
  gap: ${({ theme }) => theme.sizing.sm};
  justify-content: flex-start;
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
`;

const InfoBlock = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
  padding: ${({ theme }) => theme.sizing.sm};
`;
